<template>
    <div>
        <BasicDialog @close="closeDialog">
            <v-row>



                <v-col cols="12" class="d-flex flex-row justify-center align-center">
                    <logo-background></logo-background>
                    <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
                        <img :src="AppConfigs.staticImages.SHAREONMESSENGER" alt="Share on Messenger" style="width: 70%; height: auto; transform: scale(1.2);">
                        <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable"
                            style="position: absolute; top: -61%; left: -22%; transform: scale(0.8);">
                    </div>
                </v-col>



                <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
                    Share on Messenger
                </v-col>



                <v-col cols="12" class="text-center">
                    Share on Messenger and earn {{ coinsForSharingOnMessenger }} coins
                </v-col>



                <v-col cols="12" class="d-flex flex-row justify-center">
                    <v-btn rounded="pill" :disabled="!isAvailable"
                        class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
                        @click="shareOnMessenger">
                        Click to share
                    </v-btn>
                </v-col>



            </v-row>
        </BasicDialog>
    </div>
</template>




<script>

import { defineComponent } from 'vue';
import { AppConfigs } from "@/app.configs";
import { computed, provide, inject } from 'vue';

import { isMobile } from "@/utils/utils.ts";
import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";


export default defineComponent({
    name: 'ShareOnMessengerDialog',
    components: {
        BasicDialog,
        LogoBackground,
    },
    props: {
        dialogOpen: Boolean,
    },
    setup(props, { emit }) {
        const isMobileDevice = isMobile();
        
        let openDialog = inject('inHouseTaskOpenDialog');
        provide('openDialog', openDialog);
        const inHouseTaskStore = UserActivityStore();
        const coinsForSharingOnMessenger = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
        const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

        const messengerShareUrl = `http://www.facebook.com/dialog/send?link=https://webappdev.bountyhunterapp.co&app_id=${import.meta.env.VITE_APP_FACEBOOK_CLIENT_ID}&redirect_uri=https://webappdev.bountyhunterapp.co`;
        const messengerUrl = `fb-messenger://share?link=${encodeURIComponent(`https://webappdev.bountyhunterapp.co&app_id=${import.meta.env.VITE_APP_FACEBOOK_CLIENT_ID}`)}`;

        function closeDialog() {
            emit('close');
        }

        function shareOnMessenger() {
            if (isMobileDevice.value) {
                window.open(messengerUrl, '_blank');
            } else {
                window.open(messengerShareUrl, '_blank');
            }
            inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
        }

        return {
            AppConfigs,
            closeDialog,
            isAvailable,
            shareOnMessenger,
            coinsForSharingOnMessenger,
        };
    },
});
</script>
